/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Tabs_GeneralInputs */

const en_admin_settings_tabs_general = /** @type {(inputs: Admin_Settings_Tabs_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

const zh_admin_settings_tabs_general = /** @type {(inputs: Admin_Settings_Tabs_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常规`)
};

/**
* | output |
* | --- |
* | "General" |
*
* @param {Admin_Settings_Tabs_GeneralInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_tabs_general = /** @type {((inputs?: Admin_Settings_Tabs_GeneralInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Tabs_GeneralInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_tabs_general(inputs)
	return zh_admin_settings_tabs_general(inputs)
});
export { admin_settings_tabs_general as "admin.settings.tabs.general" }